import * as React from "react";
import * as ReactDOM from "react-dom/client";
import Colours from "../Tools/Colours";

const appElement = document.getElementById("app");
const root = ReactDOM.createRoot(appElement);
root.render(<Colours />);
